import { Box, CircularProgress, Collapse } from "@mui/material";
import { request } from "app/api";
import { addNomer, changeDate, editNomer } from "app/reducers/filter";
import { filterSelector, styleSelector } from "app/selectors";
import CustomIcon from "components/customIcon";
import RangePicker, { monthNamesLocal } from "components/fields/date-range/RangePicker";
import { get, isNull, isNumber } from "lodash";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useDispatch, useSelector } from "react-redux";
import AddPerson from "../addPerson";
import StyledHeaderBox from "./Styled";
import { useParams } from "react-router-dom";
import classNames from "classnames";
import { LanguageContext } from "components/language";
import { setStyle } from "app/reducers/style";
import EastIcon from "@mui/icons-material/ArrowForward";
import { getDomenFromUrl } from "utils/functions";
import { PARENT_ORIGIN } from "App";
// import EastIcon from "assets/icons/arrowRight.svg";

const containerSx = {
    maxWidth: {
        xxl: "1124px",
        xl: "972px",
        lg: "924px",
        md: "721px",
        xs: "517px",
    },
};

const MainHeader = ({ getAllCategories = () => "", loading }) => {
    const dispatch = useDispatch();
    const { hotelId, targetCategoryId } = useParams();
    const dayAmounts = useRef({ months: {}, days: {} });
    const [{ showDate, hotelInfo, showPerson }, setState] = useState({});
    const { dateRange, peopleCount, childrenCount, nomers } = useSelector(filterSelector);
    const { t } = useContext(LanguageContext);
    const design = useSelector(styleSelector);
    const filterData = useSelector(filterSelector);

    const getAmounts = useCallback((month, nextMonth) => {
        dayAmounts.current.months[month] = true;
        dayAmounts.current.months[nextMonth] = true;
        request({
            method: "get",
            url: targetCategoryId
                ? `category/get-calendar-form-v2/${hotelId}/${targetCategoryId}/${month}/${nextMonth}`
                : `category/get-calendar-form/${hotelId}/${month}/${nextMonth}`,
            success: ({ data }) => {
                Object.assign(dayAmounts.current.days, data);
                setState((s) => ({ ...s }));
            },
            fail: () => {
                dayAmounts.current.months[month] = false;
                dayAmounts.current.months[nextMonth] = false;
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const disabledButton =
        peopleCount + childrenCount === 0 ||
        !isNumber(dateRange?.startDate) ||
        !isNumber(dateRange?.endDate);

    useEffect(() => {
        request({
            url: `hotel/name/${hotelId}`,
            success: ({ data }) => {
                dispatch(setStyle(JSON.parse(get(data, "customDesignStyle", "{}"))));
                setState((s) => ({ ...s, hotelInfo: data }));
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const global = document.getElementById("global_styled");
        if (global)
            global.style.minHeight = showDate
                ? "820px"
                : showPerson
                ? nomers.length * 146 + 380 + "px"
                : "160px";
    }, [showDate, showPerson, nomers.length]);

    return (
        <StyledHeaderBox className="container" design={design} sx={containerSx}>
            <Box className={`main-header ${get(hotelInfo, "baseUrl") ? "hasUrl" : ""}`}>
                <div className="main-header__content">
                    <div className="main-header__items">
                        <div className="main-header__item location">
                            <CustomIcon icon="mark" />
                            <div className="main-header__item__content">
                                <p className="main-header__item__name">{t("YOUR_HOTEL")}</p>
                                <p className="main-header__item__title">
                                    {hotelInfo?.name || t("YOUR_HOTEL")}
                                </p>
                            </div>
                        </div>
                        <div
                            onClick={() => setState((s) => ({ ...s, showDate: !s.showDate }))}
                            className="main-header__item date"
                        >
                            <CustomIcon icon="date" />
                            <div className="main-header__item__content">
                                <p className="main-header__item__name">
                                    {t("DATE_ARRIVAL_AND_DEPARTURE")}
                                </p>
                                <p className="main-header__item__title">
                                    {get(dateRange, "startDate")
                                        ? moment(dateRange.startDate).date() +
                                          " " +
                                          t(monthNamesLocal[moment(dateRange.startDate).month()])
                                        : "-"}{" "}
                                    {get(dateRange, "endDate")
                                        ? " - " +
                                          moment(dateRange.endDate).date() +
                                          " " +
                                          t(monthNamesLocal[moment(dateRange.endDate).month()]) +
                                          ", " +
                                          moment(dateRange.endDate).year()
                                        : "-"}
                                </p>
                            </div>
                        </div>
                        <div
                            onClick={() => setState((s) => ({ ...s, showPerson: !s.showPerson }))}
                            className="main-header__item user"
                        >
                            <CustomIcon icon="user-mini" />
                            <div className="main-header__item__content">
                                <p className="main-header__item__name">{t("GUESTS_AND_ROOMS")}</p>
                                <p className="main-header__item__title">
                                    {peopleCount} {t("ADULTS")}, {childrenCount} {t("CHILDRENS")},{" "}
                                    {nomers.length || 0} {t("NUMBER")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="main-header__item-all">
                        <div
                            onClick={() => setState((s) => ({ ...s, showDate: !s.showDate }))}
                            className="main-header__item-all__item"
                        >
                            <CustomIcon icon="date" />
                            <p className="main-header__item-all__item__value">
                                {get(dateRange, "startDate")
                                    ? moment(dateRange.startDate).date() +
                                      " " +
                                      t(monthNamesLocal[moment(dateRange.startDate).month()])
                                    : "-"}{" "}
                                {get(dateRange, "endDate")
                                    ? " - " +
                                      moment(dateRange.endDate).date() +
                                      " " +
                                      t(monthNamesLocal[moment(dateRange.endDate).month()])
                                    : "-"}
                            </p>
                        </div>
                        <div
                            onClick={() => setState((s) => ({ ...s, showPerson: !s.showPerson }))}
                            className="main-header__item-all__item"
                        >
                            <CustomIcon icon="user-mini" />
                            <p className="main-header__item-all__item__value">
                                {peopleCount} {t("ADULTS")}, {childrenCount} {t("CHILDRENS")},{" "}
                                {nomers.length || 0} {t("NUMBER")}
                            </p>
                        </div>
                        <div
                            onClick={() => !disabledButton && getAllCategories()}
                            className={classNames("main-header__item-all__item button", {
                                disabled: disabledButton,
                            })}
                        >
                            {t("FIND")}
                        </div>
                    </div>
                    <div
                        onClick={() => !disabledButton && !loading && getAllCategories()}
                        className={classNames("main-header__button", {
                            disabled: disabledButton,
                        })}
                    >
                        {loading ? <CircularProgress size={30} /> : <EastIcon />}
                    </div>
                </div>
                <div className="main-header__domen">
                    {get(hotelInfo, "baseUrl") ? (
                        <p>
                            {t("BOOKING_MODULE")}{" "}
                            <a target="_blank" href={get(hotelInfo, "baseUrl")} rel="noreferrer">
                                {getDomenFromUrl(get(hotelInfo, "baseUrl"))}
                            </a>
                        </p>
                    ) : null}
                </div>
            </Box>
            <Collapse timeout={{ enter: 1000, exit: 0, appear: 1000 }} in={showDate}>
                <OutsideClickHandler
                    onOutsideClick={() => {
                        if (showDate) {
                            window.parent?.postMessage("scrollToTop", PARENT_ORIGIN);
                            setState((s) => ({ ...s, showDate: false }));
                        }
                    }}
                >
                    <div className="daterange-container">
                        <div className="daterange-body">
                            <div style={{ marginBottom: "15px" }} className="daterange-body__line">
                                {t("CHOOSE_CHECKIN_CHECKOUT_DATE")}
                            </div>
                            <RangePicker
                                design={design}
                                dayAmounts={dayAmounts.current}
                                getAmounts={getAmounts}
                                defaultDate={filterData.dateRange}
                                onChange={(date) => {
                                    if (!isNaN(date.endDate) && !isNull(date.endDate)) {
                                        window.parent?.postMessage("scrollToTop", PARENT_ORIGIN);
                                        setState((s) => ({ ...s, showDate: false }));
                                    }

                                    dispatch(changeDate(date));
                                }}
                            />
                            <div style={{ marginTop: "15px" }} className="daterange-body__line">
                                <span>
                                    {get(dateRange, "startDate")
                                        ? moment(dateRange.startDate).date() +
                                          " " +
                                          t(monthNamesLocal[moment(dateRange.startDate).month()])
                                        : ""}{" "}
                                    {get(dateRange, "endDate")
                                        ? " - " +
                                          moment(dateRange.endDate).date() +
                                          " " +
                                          t(monthNamesLocal[moment(dateRange.endDate).month()]) +
                                          ", " +
                                          moment(dateRange.endDate).year()
                                        : ""}
                                </span>
                            </div>
                        </div>
                    </div>
                </OutsideClickHandler>
            </Collapse>
            <Collapse timeout={{ enter: 1000, exit: 0, appear: 1000 }} in={showPerson}>
                <OutsideClickHandler
                    onOutsideClick={() => {
                        showPerson && setState((s) => ({ ...s, showPerson: false }));
                    }}
                >
                    <AddPerson
                        addNomer={() => dispatch(addNomer())}
                        changeNumber={(data) => dispatch(editNomer(data))}
                        nomers={nomers}
                        close={() => {
                            showPerson && setState((s) => ({ ...s, showPerson: false }));
                        }}
                        maxGuest={hotelInfo?.maxGuest || 1000}
                    />
                </OutsideClickHandler>
            </Collapse>
        </StyledHeaderBox>
    );
};

export default MainHeader;
